import React from 'react';
import { useAuth } from '../AuthContext';
import { Link } from 'react-router-dom';
import { CAMPSITE_LABEL } from '../campsite';

function Introduction(): JSX.Element {
  const { username } = useAuth();

  return (
    <div className="card">
      <h2>🏕️ About the Event</h2>
      <p><strong>📆 Dates: November 6th – 8th, 2026</strong></p>
      <p>
        <strong>
          🌳 Location:{' '}
          {username ? (
            <Link to="/location">{CAMPSITE_LABEL}</Link>
          ) : (
            'Near Chattanooga, TN'
          )}
        </strong>
      </p>
      <h3>📋 Schedule</h3>
      <p>
        The trip begins on <strong>Friday evening</strong> and wraps up <strong>Sunday morning</strong>.
        On the Sabbath, the group typically enjoys an <strong>easy hike</strong> together, followed
        by a <strong>message and group discussion</strong>.
      </p>

      <h3>🍽️ Meals Provided</h3>
      <ul>
        <li>Friday — Dinner</li>
        <li>Saturday — Breakfast, Lunch & Dinner</li>
        <li>Sunday — Breakfast</li>
      </ul>
      <p>
        <strong>Snacks, s'mores, and drinks</strong> will also be provided throughout the weekend
      </p>
      <br/>

      <h3>💵 Cost</h3>
      <p>
        The average cost per person is normally about <strong>$20</strong>, which covers
        food and the campsite for the weekend, but may vary depending on how many
        people attend.
      </p>
      <p>
        <em>Costs are collected through Venmo or Cash.</em>
      </p>
      <br />
      <p>
        We hope you can join us for this fun and meaningful weekend of fellowship and outdoor activities.
          <br/>
        <br/>
        <em>
          Details for the Camping Trip will be added to this site periodically.
        </em>
        
      </p>
    </div>
  );
}

export default Introduction;
